if (!customElements.get("select-wrapper")) {
  customElements.define(
    "select-wrapper",
    class SelectWrapper extends HTMLElement {
      constructor() {
        super();

        intersecting({
          element: this,
          callback: this.init.bind(this),
          threshold: 200,
        });

        if (Shopify.designMode) {
          setTimeout(() => {
            this.init();
          }, 200);
        }

        this.select = this.querySelector("select");
        if (this.select) {
          this.select.addEventListener(
            "change",
            this.handleSelectChange.bind(this)
          );
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this.select) this.init();
          });
        }
      }

      init() {
        if (!this.select || !this.select.options.length) return;
        const style = window.getComputedStyle(this.select);
        const value = this.select.options[this.select.selectedIndex].text;

        const text = document.createElement("span");
        text.style.fontFamily = style.fontFamily;
        text.style.fontSize = style.fontSize;
        text.style.fontWeight = style.fontWeight;
        text.style.letterSpacing = style.letterSpacing;
        text.style.textTransform = style.textTransform;
        text.style.visibility = "hidden";
        text.style.position = "absolute";
        text.style.whiteSpace = "nowrap";
        text.textContent = value;

        document.body.appendChild(text);
        const width = Math.ceil(
          text.getBoundingClientRect().width +
          parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) +
          parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth)
        ) + 2;

        this.style.setProperty("--width", `${width}px`);
        text.remove();
      }

      handleSelectChange() {
        this.init();
      }
    }
  );
}

if (!customElements.get("product-bundle")) {
  customElements.define(
    "product-bundle",
    class ProductBundle extends HTMLElement {
      constructor() {
        super();

        this.priceEl = this.querySelector("[data-bundle-price]");
        this.comparePriceEl = this.querySelector("[data-bundle-compare-price]");
        this.variants = this.querySelector("select");
        this.cartBtn = this.querySelector("[data-bundle-add-single]");

        if (this.variants) {
          this.variants.addEventListener(
            "change",
            this.onSelectChange.bind(this)
          );
        }
      }

      onSelectChange(event) {
        const variants = event.target;
        const variant = variants.options[variants.selectedIndex];
        const compare_at_price = parseInt(variant.dataset.compare_at_price || 0);
        const price = parseInt(variant.dataset.price || 0);
        const available = variant.dataset.available === "true";

        if (this.priceEl) {
          this.priceEl.innerHTML = formatMoney(price, window.FoxThemeSettings.money_format);
        }

        if (compare_at_price > price) {
          if (this.comparePriceEl) {
            this.comparePriceEl.innerHTML = "<s>" + formatMoney(compare_at_price, window.FoxThemeSettings.money_format) + "</s>";
            this.comparePriceEl.style.display = "";
          } else {
            var span = document.createElement("span");
            span.className = "products-bundle__price-compare";
            span.setAttribute("data-bundle-compare-price", "");
            span.innerHTML = "<s>" + formatMoney(compare_at_price, window.FoxThemeSettings.money_format) + "</s>";
            this.priceEl.parentNode.appendChild(span);
            this.comparePriceEl = span;
          }
        } else if (this.comparePriceEl) {
          this.comparePriceEl.style.display = "none";
        }

        if (this.cartBtn) {
          this.cartBtn.setAttribute("data-variant-id", variants.value);
          this.cartBtn.disabled = !available;
        }
      }
    }
  );
}

if (!customElements.get("products-bundle")) {
  customElements.define(
    "products-bundle",
    class ProductsBundle extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          hover: "is-hover",
          active: "is-active",
        };

        this.cartDrawer = document.querySelector("cart-drawer");
        this.mainCart = document.querySelector("cart-items");
        this.button = this.querySelector(".products-bundle__button-atc");
        this.Notification = window.FoxTheme.Notification;
        this.errorWrapper = this.querySelector(".product-form__error-message");
        if (this.button)
          this.button.addEventListener("click", this.onButtonClick.bind(this));

        this.blocks = this.querySelectorAll("[data-block-id]");
        this.blocks.forEach((block) =>
          block.addEventListener("mouseenter", this.onEnterHandler.bind(this))
        );
        this.blocks.forEach((block) =>
          block.addEventListener("mouseleave", this.onLeaveHandler.bind(this))
        );

        // Per-product add-to-cart
        this.querySelectorAll("[data-bundle-add-single]").forEach((btn) =>
          btn.addEventListener("click", (e) => this.handleAddToCart(e, btn))
        );

        // Sample add-to-cart
        this.querySelectorAll("[data-bundle-sample-add]").forEach((btn) =>
          btn.addEventListener("click", (e) => this.handleAddToCart(e, btn))
        );
      }

      handleAddToCart(event, button) {
        event.preventDefault();
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        button.disabled = true;
        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", 1);

        let sectionToBundle = [];
        if (this.cartDrawer) {
          sectionToBundle = this.cartDrawer
            .getSectionsToRender()
            .map((section) => section.id);
        }
        formData.append("sections", sectionToBundle);
        formData.append("sections_url", window.location.pathname);

        fetch(FoxThemeSettings.routes.cart_add_url, {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: formData,
        })
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              this.Notification.show({
                target: this.errorWrapper || document.body,
                method: "appendChild",
                type: "warning",
                message: response.description,
                last: 3000,
              });
              return;
            }
            if (
              !FoxThemeSettings.cart.openDrawerWhenAdded ||
              FoxThemeSettings.cart.cartType === "page"
            ) {
              this.Notification.show({
                target: this.errorWrapper || document.body,
                method: "appendChild",
                type: "success",
                message: FoxThemeStrings.item_added,
                last: 3000,
              });
            }
            if (FoxThemeSettings.cart.cartType === "page") {
              FoxThemeCartHelpers.getState().then((state) => {
                FoxThemeCartHelpers.updateCartCount(state.item_count);
              });
            }
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
            document.dispatchEvent(
              new CustomEvent("product-ajax:added", {
                detail: { product: response },
              })
            );
          })
          .catch((e) => console.error(e))
          .finally(() => {
            button.disabled = false;
          });
      }

      onButtonClick(event) {
        event.preventDefault();

        const ids = this.querySelectorAll('[name="id"]');
        const items = {
          items: [...ids]
            .map((e) => e.value)
            .map((e) => ({
              id: e,
              quantity: 1,
            })),
        };

        this.button.setAttribute("disabled", "true");
        this.button.classList.add("btn--loading");

        let sectionToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:grouped-sections", {
            bubbles: true,
            detail: { sections: sectionToBundle },
          })
        );

        if (this.cartDrawer) {
          sectionToBundle = [
            ...sectionToBundle,
            ...this.cartDrawer
              .getSectionsToRender()
              .map((section) => section.id),
          ];
        }

        if (this.mainCart) {
          sectionToBundle = [
            ...sectionToBundle,
            ...this.mainCart
              .getSectionsToRender()
              .map((section) => section.section),
          ];
        }

        const body = JSON.stringify({
          ...items,
          sections: sectionToBundle,
          sections_url: window.location.pathname,
        });

        const config = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/javascript",
          },
        };
        config.body = body;
        fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.Notification.show({
                target: this.errorWrapper ? this.errorWrapper : document.body,
                method: "appendChild",
                type: "warning",
                message: response.description,
                last: 3000,
              });

              // Dispatch event for third-party
              document.dispatchEvent(
                new CustomEvent("product-ajax:error", {
                  detail: {
                    errorMessage: response.description,
                  },
                })
              );

              return;
            }

            if (
              !FoxThemeSettings.cart.openDrawerWhenAdded ||
              FoxThemeSettings.cart.cartType === "page"
            ) {
              this.Notification.show({
                target: this.errorWrapper ? this.errorWrapper : document.body,
                method: "appendChild",
                type: "success",
                message: FoxThemeStrings.item_added,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }

            if (FoxThemeSettings.cart.cartType === "page") {
              FoxThemeCartHelpers.getState().then((state) => {
                FoxThemeCartHelpers.updateCartCount(state.item_count);
              });
            }
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);

            // DispatchEvent for third-party
            document.dispatchEvent(
              new CustomEvent("product-ajax:added", {
                detail: {
                  product: response,
                },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.button.classList.remove("btn--loading");
            this.button.removeAttribute("disabled");
          });
      }

      onEnterHandler(event) {
        this.classList.add(this.classes.hover);

        const target = event.target;
        const blockId = target.dataset.blockId;
        this.blocks.forEach((block) => {
          if (target.nodeName === "PRODUCT-BUNDLE") {
            if (block.nodeName === "PRODUCT-BUNDLE") {
              block.classList.add(this.classes.active);
              return;
            }
          }
          if (block.dataset.blockId === blockId) {
            block.classList.add(this.classes.active);
          }
        });
      }

      onLeaveHandler() {
        this.classList.remove(this.classes.hover);
        this.blocks.forEach((block) =>
          block.classList.remove(this.classes.active)
        );
      }
    }
  );
}
